import React, { useState } from "react";
import { BarChart3 } from "lucide-react";
import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";

import { transformLocalChartData } from "../../../utils/marketLabChartUtils";
import MarketLabChartTemplate from "../../charts/MarketLabChartTemplate";

export const ChartCell = ({ data, columnInfo, rowId }) => {
  const [isChartOpen, setIsChartOpen] = useState(false);

  const chartData = transformLocalChartData(data);
  const hasData = chartData.length > 0;

  return (
    <>
      <div className="flex items-center justify-center p-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsChartOpen(true)}
          disabled={!hasData}
          className="flex items-center gap-1 text-xs"
        >
          <BarChart3 className="h-3 w-3" />
          View Charts
        </Button>
      </div>

      <Dialog open={isChartOpen} onOpenChange={setIsChartOpen}>
        <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {columnInfo.display} - Row {rowId}
            </DialogTitle>
          </DialogHeader>
          <div className="mt-4">
            {hasData ? (
              <MarketLabChartTemplate
                title={`${columnInfo.display} Over Time`}
                description="Individual item performance data"
                data={chartData}
                footerText="Chart data from selected table row"
              />
            ) : (
              <div className="text-center py-8">
                <BarChart3 className="h-12 w-12 text-gray-400 mx-auto mb-2" />
                <div className="text-gray-500">No chart data available</div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
